import React, { FC, useCallback, useEffect, useState } from 'react'
import { Grid, Typography, Box } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useParams } from 'react-router'
import { toast } from 'react-toastify'
import { GetUserProfileResponseDto } from '@sparling/financial-common'
import { UserInfo } from './UserInfo'
import { KYCStatus } from './KYCStatus'
import { General } from './General'
import { TradeHistory } from './TradeHistory'
import { LoginHistory } from './LoginHistory'
import { TransactionHistory } from './TransactionHistory'
import { useRest } from '../../../components/Context'
import { GridRow } from '../../../components/GridRow'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    boxSizing: 'border-box',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  withoutTitle: {
    paddingTop: 40,
  },
}))

// eslint-disable-next-line
export const AccountUser: FC = () => {
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  // eslint-disable-next-line
  const { id } = useParams() as { [key: string]: string }
  const [userAccount, setUserAccount] = useState<null | GetUserProfileResponseDto>(null)
  const [loadingUserData, setLoadingUserData] = useState<boolean>(true)

  const loadData = useCallback(async () => {
    if (id) {
      setLoadingUserData(true)

      rxiosAuth.get(`admin/user-profile/${id}`).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setUserAccount(next)
          // console.log(next)
          setLoadingUserData(false)
        },
        (error) => {
          toast.error(error)
          setLoadingUserData(true)
        },
      )
    }
  }, [rxiosAuth, id])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <Box className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h1">Account</Typography>
      </Grid>

      <GridRow spacing={4}>
        <Grid item xs={6} className={classes.withoutTitle}>
          <UserInfo title={'User Info'} loading={loadingUserData} userAccount={userAccount} />
        </Grid>
        <Grid item xs={6}>
          <KYCStatus title={'KYC Status'} idSf={id} />
        </Grid>
      </GridRow>

      <GridRow spacing={4}>
        <Grid item xs={6}>
          <General loading={loadingUserData} userAccount={userAccount} idSf={id} refresh={loadData} />
        </Grid>
        <Grid item xs={6}>
          <TradeHistory title={'Trade History'} idSf={id} />
        </Grid>
      </GridRow>

      <GridRow spacing={4}>
        <Grid item xs={6}>
          <LoginHistory title={'Login History'} idSf={id} />
        </Grid>
        <Grid item xs={6}>
          <TransactionHistory title={'Transaction History'} idSf={id} />
        </Grid>
      </GridRow>
    </Box>
  )
}
